// store/properties/propertyCategoriesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri } from "../../utilities/apiManager";

const initialState = {
  isLoading: false,
  data: [], // array of categories
  error: null,
};

export const getPropertyCategories = createAsyncThunk(
  "properties/getPropertyCategories",
  async (_, thunkApi) => {
    try {
      const { data } = await axios.get(`${apiUri}/properties/categories`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          "Accept-Language": document.documentElement.lang,
        },
      });
      return thunkApi.fulfillWithValue(data); // { data: [...] }
    } catch (errors) {
      return thunkApi.rejectWithValue(
        errors?.response?.data || { message: "Network error" }
      );
    }
  }
);

const propertyCategoriesSlice = createSlice({
  name: "propertyCategories",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPropertyCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPropertyCategories.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload?.data || []; // API shape: { data: [...] }
        state.error = null;
      })
      .addCase(getPropertyCategories.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message || "Failed to load categories";
      });
  },
});

export default propertyCategoriesSlice.reducer;
